import {
  Activity,
  Archive,
  ArrowRight,
  ArrowUp,
  BadgeCheck,
  BarChart3,
  Banknote,
  Bell,
  Bot,
  Brain,
  Boxes,
  BookOpen,
  Briefcase,
  Building,
  Building2,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDot,
  CirclePlus,
  ClipboardList,
  Clock,
  Compass,
  CreditCard,
  Database,
  Eye,
  EyeOff,
  Facebook,
  FileBarChart,
  FileCheck,
  FileText,
  Flame,
  Folder,
  Gauge,
  GitBranch,
  GripVertical,
  Headphones,
  HeartPulse,
  HelpCircle,
  History,
  Home,
  Inbox,
  Key,
  Landmark,
  Layers,
  LifeBuoy,
  Linkedin,
  LineChart,
  List,
  Loader2,
  LogOut,
  Mail,
  MapPin,
  Menu,
  MessageCircle,
  MessageSquare,
  Mic,
  Minus,
  Instagram,
  Package,
  PackageCheck,
  Paperclip,
  Palette,
  Plus,
  Percent,
  Radio,
  RefreshCcw,
  Search,
  Settings,
  Shield,
  ShieldCheck,
  ShoppingBag,
  ShoppingCart,
  Shuffle,
  Smile,
  Sparkles,
  SlidersHorizontal,
  Tags,
  Star,
  Target,
  ThumbsDown,
  ThumbsUp,
  TriangleAlert,
  TrendingDown,
  TrendingUp,
  Truck,
  User,
  UserCircle,
  Users,
  Wallet,
  Workflow,
  X,
  XCircle,
  Zap,
} from 'lucide-angular';

export const LUCIDE_ICONS = {
  Activity,
  ArrowRight,
  ArrowUp,
  Home,
  ShoppingCart,
  ShoppingBag,
  Package,
  RefreshCcw,
  Archive,
  Layers,
  LifeBuoy,
  Workflow,
  Users,
  Palette,
  FileText,
  Folder,
  BarChart3,
  LineChart,
  List,
  FileBarChart,
  Shield,
  ShieldCheck,
  FileCheck,
  Key,
  Landmark,
  User,
  Settings,
  Briefcase,
  Building,
  Radio,
  MapPin,
  GitBranch,
  Gauge,
  GripVertical,
  Boxes,
  BookOpen,
  ClipboardList,
  Wallet,
  Search,
  CreditCard,
  Percent,
  Banknote,
  Truck,
  PackageCheck,
  Paperclip,
  Plus,
  SlidersHorizontal,
  Star,
  ThumbsDown,
  Bell,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronUp,
  ChevronRight,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleDot,
  CirclePlus,
  Database,
  Menu,
  Building2,
  UserCircle,
  LogOut,
  Mail,
  Clock,
  MessageCircle,
  MessageSquare,
  Mic,
  Minus,
  Eye,
  EyeOff,
  Facebook,
  Flame,
  Sparkles,
  Bot,
  Brain,
  Smile,
  TrendingUp,
  TrendingDown,
  TriangleAlert,
  Target,
  ThumbsUp,
  Compass,
  Shuffle,
  Tags,
  HeartPulse,
  Headphones,
  HelpCircle,
  History,
  Instagram,
  Linkedin,
  X,
  Zap,
  // Order Workflow tab icons
  Inbox,
  BadgeCheck,
  XCircle,
  Loader2,
};
